import { isEditingAtom } from '@atoms/admin';
import { useAtom } from 'jotai';

export function useLazyLoad(lazyLoad: boolean | undefined): boolean {
    const [isEditing] = useAtom(isEditingAtom);
    const shouldLazyLoad = lazyLoad ? lazyLoad && !isEditing : false;

    return shouldLazyLoad;
}
